// extracted by mini-css-extract-plugin
export default {"container":"ResultTitle_container__LFb3h"};